const routes = [
  {
    path: "/messages",
    name: "MyMessages",
    component: () =>
      import(
        /* webpackChunkName: "mymessages" */ "@/pages/MyMessages/MyMessagesIndex"
      ),
    meta: {
      title: "My Messages - NutriBit",
      showSearch: true
    }
  }
];

export default routes;
